import React, { useEffect, useRef, useState } from 'react';
import { useMutation, gql, useQuery, useApolloClient } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import { GetCustomerNestPass } from '../../apollo';
import { Button, Box, Typography, Grid, Paper, TextField, Autocomplete, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Snackbar } from '@mui/material';
import { Icon } from '@iconify/react';
import useStyles from '../ChangeCustomerType/styles';
import useGlobalStyles from '../../utils/globalStyles';
import DataTable from 'react-data-table-component';
import TableHeader from '../TableHeader';
import { customStyles } from '../../utils/customTableForNestPass';
import CustomLoader from '../Loader/CustomLoader';

const GET_CUSTOMER_NESTPASS = gql`
  ${GetCustomerNestPass}
`;

const CustomPaperComponent = (props) => (
  <Paper {...props} style={{ background: 'white', color: 'black' }} />
);

function ViewNestPass(props) {
  const { onClose, customerPhone } = props;
  const formRef = useRef();
  let [error, errorSetter] = useState('');
  const [success, successSetter] = useState('');
  const { t } = props;
  const [selectedWorker, setSelectedWorker] = useState(props.vendor ? props.vendor.storeName : null);
  const [formErrors, setFormErrors] = useState({});
  const client = useApolloClient();
  const [workerError, setWorkerError] = useState(false);
  const [formData, setFormData] = useState({
    customerType: props.vendor ? props.vendor.customerType : '',
  });
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const inputTextStyle = { color: 'black' };

  const [openSnackk, setopenSnackk] = useState(false);
  const [page, setPage] = useState(1);
  const [tabledata, setTabledata] = useState(null);
  const [currentPage, setCurrentPage] = useState(page);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const variables = {
    customerPhone: customerPhone, // Use customerPhone from props
    limit: perPage,
    skip: (page - 1) * perPage,
  };
  const getMembershipLabel = (status) => {
    switch (parseInt(status)) {
      case 0:
        return 'Member';
      case 1:
        return 'Not a Member';
      default:
        return 'Unknown';
    }
  };
 
  const { data: customerNestPassDetails, loading: loadingQuery, refetch } = useQuery(GET_CUSTOMER_NESTPASS, {
    variables: variables,
   
    onCompleted: (data) => {
      if (data && data.getCustomerNestPass) { 
        setTabledata(data.getCustomerNestPass.nestPassMemberships || []);
        setTotalRows(data.getCustomerNestPass.nestPassMembershipCount || 0);
      } else {
        setTabledata([]);
        setTotalRows(0);
      }
    },
    onError: (error) => {
      const isForbiddenError = error && error.graphQLErrors.some((err) => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        // Assuming props has a history object for navigation
        if (props.history && props.history.push) {
          props.history.push('/auth/login');
        } else {
          console.error("History object not available in props for navigation.");
        }
      } else {
        console.error("GraphQL Error:", error);
        errorSetter("Error fetching Nest Pass details.");
        setopenSnackk(true);
      }
    },
  });

  const handlePerRowChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to the first page when rows per page change
  };
  // Inside your handlePageChange function, update the local storage
  const handlePageChange = (newPage) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };
  useEffect(() => {
    refetch({
      limit: perPage,
      skip: (page - 1) * perPage,
    });
  }, [page, perPage, refetch]);

  const formatDateInIST = (dateValue) => {
    if (!dateValue) return "-";

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const columns = [
    {
      name: "Sl No",
      selector: (row, index) => index + 1,
    },
    {
      name: "Membership Date",
      selector: (row) => row.membershipDate,
      sortable: true,
      wrap: true,
      format: (row) => formatDateInIST(row.membershipDate),
    },
    {
      name: "Expiry Date",
      selector: (row) => row.membershipExpiryDate,
      sortable: true,
      wrap: true,
      format: (row) => formatDateInIST(row.membershipExpiryDate),
    },
    {
      
        name: "Type",
        selector: (row) => row.type,
        sortable: true,
        format: (row) => {
          switch (row.type) {
            case 0: // Assuming the backend returns numerical values
              return "Purchased";
            case 1:
              return "By Admin";
            case 2:
              return "Cancelled by Admin";
            case 3:
              return "Expired";
            default:
              return "Unknown";
          }
        },
      
      selector: (row) => row.type,
      sortable: true,
      wrap: true
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    /* {
      name: "Payment Status",
      selector: (row) => row.onlinePaymentStatus, // Assuming your data has 'onlinePaymentStatus'
      sortable: true,
      format: (row) => {
        switch (row.onlinePaymentStatus) {
          case 0: // PHONEPAY_PAYMENT_STATUS.PENDING
            return "Pending";
          case 1: // PHONEPAY_PAYMENT_STATUS.INITIALIZED
            return "Initialized";
          case 2: // PHONEPAY_PAYMENT_STATUS.SUCCESS
            return "Success";
          case 3: // PHONEPAY_PAYMENT_STATUS.FAILED
            return "Failed";
          case 4: // PHONEPAY_PAYMENT_STATUS.CANCELLED
            return "Cancelled";
          case 5: // PHONEPAY_PAYMENT_STATUS.DECLINED
            return "Declined";
          case 6: // PHONEPAY_PAYMENT_STATUS.NOT_APPLICABLE
            return "Not Applicable";
          case 7: // PHONEPAY_PAYMENT_STATUS.FAILED_TIMED_OUT
            return "Failed (Timed Out)";
          default:
            return "Unknown";
        }
      },
    },
     */
    {
      name: "Pmt Rfd Status",
      selector: (row) => row.canceledRefundStatus, // Assuming your data has 'onlinePaymentStatus'
      sortable: true,
      wrap: true,
      format: (row) => {
        switch (row.canceledRefundStatus) {
          case 0: // PHONEPAY_REFUND_STATUS.NOT_APPLICABLE
            return "Not Applicable";
          case 1: //// PHONEPAY_REFUND_STATUS. REFUND_PENDING
            return "Pending";
          case 2: // PHONEPAY_REFUND_STATUS. REFUND_INITIATED
            return "Initiated";
          case 3: // PHONEPAY_REFUND_STATUS.REFUND_SUCCESS
            return "Success";
          case 4: // PHONEPAY_REFUND_STATUS.REFUND_FAILED
            return "Failed";
          case 5: // PHONEPAY_REFUND_STATUS.REFUND_APPLICABLE
            return "Applicable";
          default:
            return "Unknown";
        }
      },
    },
    {
      name: "Cancelled On",
      selector: (row) => row.cancelledOn,
      sortable: true,
      wrap: true,
      format: (row) => formatDateInIST(row.cancelledOn),
    },
    {
      name: "Rfd Amt (Pend)",
      selector: (row) => row.cancelRefundPendingAmount,
      sortable: true,
      style: {
        minWidth: '180px',
        maxWidth: '220px',
        textAlign: 'center',
      },
      format: (row) => row.cancelRefundPendingAmount || '-',
    },

    {
      name: "Cancellation Reason",
      selector: (row) => row.reason,
      wrap: true,
      style: {
        minWidth: '520px',
        maxWidth: '620px',
        whiteSpace: 'normal',
        textAlign: 'left',
        wordBreak: 'break-word',
      },
      format: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'left',
          width: '100%',
        }}>
          {row.reason || '-'}
        </div>
      ),
    },
    // Add more columns as needed
  ];
  return (
    <Dialog
      open={true}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      maxWidth="lg"
      fullWidth={true}
    >
      <form ref={formRef}>
        <DialogTitle>
          <Box className={props.vendor ? classes.heading : classes.heading}>
            <Typography className={props.vendor ? classes.textWhite : classes.textWhite}>
              {props.vendor ? t('Edit Product') : t('Nest Pass Details ')}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {!props.vendor ? (
              <>
                <Grid item xs={12} md={12} container direction="row" alignItems="center">
                  <Grid item xs={3} md={3}>
                    <Typography className={classes.typographyOrder} style={{ color: "black" }}>
                      Customer ID :
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} style={{ fontWeight: 600, textAlign: "center", color: "black" }}>
                    <Typography variant="body1" style={{ display: 'flex', alignItems: 'center', marginLeft: "-5px", fontSize: "14px" }}>
                    {customerNestPassDetails && customerNestPassDetails.getCustomerNestPass && customerNestPassDetails.getCustomerNestPass.customerId || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} container direction="row" alignItems="center">
                  <Grid item xs={3} md={3}>
                    <Typography className={classes.typographyOrder} style={{ color: "black" }}>
                      Phone:
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} style={{ fontWeight: 600, textAlign: "center", color: "black" }}>
                    <Typography variant="body1" style={{ display: 'flex', alignItems: 'center', marginLeft: "-5px", fontSize: "14px" }}>
                    {customerNestPassDetails && customerNestPassDetails.getCustomerNestPass && customerNestPassDetails.getCustomerNestPass.customerPhone || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} container direction="row" alignItems="center">
                  <Grid item xs={3} md={3}>
                    <Typography className={classes.typographyOrder} style={{ color: "black" }}>
                      Status:
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} style={{ fontWeight: 600, textAlign: "center", color: "black" }}>
                    <Typography variant="body1" style={{ display: 'flex', alignItems: 'center', marginLeft: "-5px", fontSize: "14px" }}>
                       {customerNestPassDetails && customerNestPassDetails.getCustomerNestPass && customerNestPassDetails.getCustomerNestPass.membershipStatus !== undefined
                        ? getMembershipLabel(customerNestPassDetails.getCustomerNestPass.membershipStatus)
                        : "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
                 {customerNestPassDetails && customerNestPassDetails.getCustomerNestPass && customerNestPassDetails.getCustomerNestPass.membershipStatusMessage && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
                      {customerNestPassDetails.getCustomerNestPass.membershipStatusMessage}
                    </Typography>
                  </Grid>
                )}
              </>
            ) : (
              <>
                {/* Additional fields for vendor */}
              </>
            )}
          </Grid>

          <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
            <DataTable
              subHeader={true}
              title={<TableHeader title={t('Membership History')} />}
              columns={columns}
              data={tabledata || []} // Use tabledata which should now hold nestPassMemberships
              pagination
              striped
              highlightOnHover
              responsive
              fixedHeader
              fixedHeaderScrollHeight="42vh"
              progressPending={loadingQuery}
              progressComponent={<CustomLoader />}
              customStyles={customStyles}
              paginationDefaultPage={currentPage}
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowChange}
              onChangePage={handlePageChange}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className={globalClasses.modalCancleBtn}
            onClick={() => {
              onClose();
            }}
          >
            Close
          </Button>
        </DialogActions>
      </form>
      <Box mt={2}>
        {success && (
          <Snackbar open={openSnackk} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
              {success}
            </Alert>
          </Snackbar>
        )}
        {error && (
          <Snackbar open={openSnackk} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity="error" variant="filled" sx={{ width: '100%' }}>
              {error}
            </Alert>
          </Snackbar>
        )}
      </Box>
    </Dialog>
  );
}

export default withTranslation()(ViewNestPass);
